module.exports = __webpack_public_path__ + "img/faceMask.37547239.png";